export const arContent = {
  introduction: {
    content: [
      "منذ ظهورها الأول في عام 1996، استحوذت سلسلة بوكيمون على قلوب الناس في جميع أنحاء العالم، لتصبح واحدة من أكثر العلامات التجارية الترفيهية شعبية على مستوى العالم. تم تصميم مولّد البوكيمون العشوائي الخاص بنا للمدربين من جميع الأعمار الذين يرغبون في اكتشاف بوكيمون جديدة، أو بناء فرق متوازنة، أو ببساطة الاستمتاع بعنصر المفاجأة في رحلتهم مع البوكيمون.",
      "سواء كنت مدربًا متمرسًا تبحث عن إلهام لفريقك القادم في البطولة أو معجبًا عاديًا يرغب في توسيع البوكيديكس الخاص به، تقدم أداة توليد البوكيمون العشوائية هذه طريقة ممتعة وتفاعلية لاستكشاف عالم البوكيمون الواسع."
    ]
  },
  howToUse: {
    content: [
      "استخدام منتقي البوكيمون العشوائي الخاص بنا بسيط وبديهي. اتبع هذه الخطوات لبدء إنشاء فريق البوكيمون المثالي الخاص بك:",
      {
        type: "orderedList",
        items: [
          { type: "text", content: "حدد عدد البوكيمون: اختر عدد البوكيمون التي تريد توليدها (1-8)." },
          { type: "text", content: "اختر نوعًا: قم بالتصفية حسب أنواع محددة مثل النار والماء والكهرباء، أو حدد \"الكل\" لتضمين جميع الأنواع." },
          { type: "text", content: "حدد جيلاً: اختر من الجيل الأول حتى الثامن، أو حدد \"الكل\" لتضمين البوكيمون من جميع الأجيال." },
          { type: "text", content: "حدد تفضيلات الندرة: قرر مدى ندرة البوكيمون التي سيتم توليدها." },
          { type: "text", content: "انقر على \"توليد\": بمجرد تحديد تفضيلاتك، انقر على الزر لتوليد بوكيمون تتطابق مع معاييرك." },
          { type: "text", content: "استكشف النتائج: راجع المعلومات التفصيلية لكل بوكيمون، بما في ذلك الإحصائيات والقدرات والأنواع والمزيد!" }
        ]
      },
      "يمكنك تكرار هذه العملية كما تشاء، مع ضبط المعايير لاكتشاف مجموعات مختلفة من البوكيمون."
    ]
  },
  benefits: {
    content: [
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "مجاني تمامًا: مولّد البوكيمون العشوائي الخاص بنا مجاني 100%، بدون رسوم خفية أو اشتراكات." },
          { type: "text", content: "تجربة قابلة للتخصيص: قم بالتصفية حسب النوع والجيل والندرة لتخصيص اختياراتك العشوائية." },
          { type: "text", content: "أداة تعليمية: تعلم عن مختلف أنواع البوكيمون وإحصائياتها وقدراتها وأنواعها." },
          { type: "text", content: "بناء الفريق: قم بتوليد فرق متوازنة بسرعة للعب العادي أو المعارك التنافسية." },
          { type: "text", content: "منشئ التحديات: قم بإنشاء تحديات فريدة من خلال تقييد نفسك بالبوكيمون المولدة عشوائياً." },
          { type: "text", content: "لا حاجة لحساب: استخدم الأداة فوراً بدون تسجيل أو معلومات شخصية." }
        ]
      }
    ]
  },
  history: {
    content: [
      "بدأت سلسلة بوكيمون في عام 1996 عندما قام ساتوشي تاجيري بإنشاء أول ألعاب بوكيمون لجهاز Game Boy من نينتندو. مستوحى من هوايته في جمع الحشرات في طفولته، تمحور المفهوم حول اصطياد وتدريب والقتال مع مخلوقات تسمى \"بوكيت مونسترز\" أو بوكيمون.",
      "المعالم الرئيسية في تاريخ بوكيمون:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "1996: إطلاق بوكيمون الأحمر والأخضر في اليابان" },
          { type: "text", content: "1998: الإطلاق الدولي لبوكيمون الأحمر والأزرق" },
          { type: "text", content: "1999: إطلاق لعبة بطاقات بوكيمون التجارية عالمياً" },
          { type: "text", content: "2000: تقديم الذهبي والفضي، مع إضافة 100 بوكيمون جديدة" },
          { type: "text", content: "2016: إطلاق بوكيمون GO، جلب السلسلة إلى المنصات المحمولة" },
          { type: "text", content: "2019: ظهور بوكيمون سورد وشيلد على نينتندو سويتش" }
        ]
      },
      "اليوم، مع أكثر من 900 نوع مختلف من البوكيمون عبر ثمانية أجيال، توسعت السلسلة لتشمل ألعاب الفيديو والبطاقات التجارية والمسلسلات المتحركة والأفلام والبضائع وتطبيقات الهواتف المحمولة، مما جعلها واحدة من أكثر امتيازات الوسائط ربحاً على الإطلاق."
    ]
  },
  popularPokemon: {
    content: [
      "على مر تاريخ بوكيمون، أصبحت العديد من الأنواع رموزاً أيقونية للسلسلة:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "بيكاتشو: تميمة السلسلة من نوع الكهرباء، المعروف بذيله على شكل برق وخدوده الوردية." },
          { type: "text", content: "تشاريزارد: المفضل لدى المعجبين من نوع النار/الطيران المعروف بمظهره الشبيه بالتنين وقدراته القوية." },
          { type: "text", content: "ميوتو: بوكيمون أسطوري من نوع النفسي تم إنشاؤه من خلال التلاعب الجيني بميو، معروف بقوته الهائلة." },
          { type: "text", content: "إيفي: محبوب لقدرته الفريدة على التطور إلى أنواع مختلفة، بما في ذلك فابوريون وجولتيون وفلاريون." },
          { type: "text", content: "جيرادوس: بوكيمون مخيف من نوع الماء/الطيران يتطور من ماجيكارب المتواضع." },
          { type: "text", content: "لوكاريو: نوع قتال/فولاذ معروف بقدراته على استشعار الهالة وشعبيته في اللعب التنافسي." },
          { type: "text", content: "جرينينجا: بوكيمون ضفدع نينجا من نوع الماء/الظلام اكتسب شعبية من خلال المسلسل المتحرك." }
        ]
      },
      "يمنحك مولّد البوكيمون العشوائي الخاص بنا فرصة لاكتشاف هذه المخلوقات الأيقونية والعديد من الأنواع الأقل شهرة ولكنها مثيرة للاهتمام بنفس القدر."
    ]
  },
  popularGames: {
    content: [
      "أنتجت سلسلة ألعاب بوكيمون العديد من العناوين المحبوبة عبر منصات متعددة:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "بوكيمون الأحمر والأزرق والأصفر: الألعاب الأصلية التي بدأت الظاهرة على Game Boy." },
          { type: "text", content: "بوكيمون الذهبي والفضي والكريستال: قدمت منطقة جوتو ودورات الليل والنهار." },
          { type: "text", content: "بوكيمون روبي وسافاير وإيميرالد: وسعت العالم بمنطقة هوين والمعارك المزدوجة." },
          { type: "text", content: "بوكيمون دايموند وبيرل وبلاتينوم: جلبت السلسلة إلى نينتندو DS مع وظائف الإنترنت." },
          { type: "text", content: "بوكيمون بلاك ووايت: قدمت مجموعة جديدة تماماً من البوكيمون ونهجاً أكثر تركيزاً على القصة." },
          { type: "text", content: "بوكيمون X و Y: قدمت نماذج ثلاثية الأبعاد والتطور الميجا." },
          { type: "text", content: "بوكيمون صن ومون: أعادت اختراع نظام الصالات مع تجارب الجزر." },
          { type: "text", content: "بوكيمون GO: لعبة الواقع المعزز المحمولة التي أصبحت ظاهرة عالمية." },
          { type: "text", content: "بوكيمون سورد وشيلد: جلبت السلسلة إلى نينتندو سويتش مع مفهوم المنطقة البرية." },
          { type: "text", content: "بوكيمون ليجندز: أرسيوس: نهج عالم مفتوح جديد للسلسلة." }
        ]
      },
      "تقدم كل لعبة آليات وبوكيمون جديدة، موسعة الكون الذي يساعدك مولّد البوكيمون العشوائي الخاص بنا على استكشافه."
    ]
  },
  tradingContests: {
    content: [
      "كان تبادل البوكيمون جانباً أساسياً من السلسلة منذ البداية. تم إصدار الألعاب الأصلية في أزواج خصيصاً لتشجيع اللاعبين على التبادل مع الأصدقاء لإكمال البوكيديكس الخاص بهم. ساعد هذا العنصر الاجتماعي في نشر شعبية بوكيمون ولا يزال مهماً اليوم.",
      "الجوانب الرئيسية للتبادل:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "بوكيمون حصرية للإصدار لا يمكن الحصول عليها إلا من خلال التبادل" },
          { type: "text", content: "تطورات التبادل لأنواع معينة مثل ماتشوك وكادابرا" },
          { type: "text", content: "أنظمة التبادل العالمية في الألعاب الحديثة تتيح التبادلات العالمية" },
          { type: "text", content: "تبادل البوكيمون النادرة أو اللامعة كرموز للمكانة" }
        ]
      },
      "تقدم مسابقات البوكيمون، التي تم تقديمها في الجيل الثالث، بديلاً للمعارك حيث تتنافس البوكيمون على أساس المظهر والأداء والجاذبية بدلاً من القوة. تشمل هذه المسابقات:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "فئات مسابقات مختلفة (الروعة، الجمال، اللطف، الذكاء، القوة)" },
          { type: "text", content: "حركات خاصة مصممة خصيصاً للمسابقات" },
          { type: "text", content: "إدارة حالة البوكيمون من خلال التوت والبوكيبلوكس" },
          { type: "text", content: "مسابقات متعددة المراحل مع تقييمات بصرية أولية وجولات عرض" }
        ]
      },
      "يمكن لمولّد البوكيمون العشوائي الخاص بنا مساعدتك في اكتشاف بوكيمون قد تتفوق في المسابقات أو تصبح شركاء تبادل قيمين، مضيفاً بعداً آخر لتجربتك مع البوكيمون."
    ]
  },
  faq: {
    content: [
      {
        type: "faqList",
        items: [
          { 
            type: "faq",
            question: "هل مولّد البوكيمون العشوائي هذا مجاني؟",
            answer: "نعم، أداتنا مجانية تماماً بدون تكاليف خفية أو متطلبات اشتراك."
          },
          {
            type: "faq",
            question: "ما مدى دقة بيانات البوكيمون؟",
            answer: "جميع البيانات مستمدة من PokéAPI الرسمية، مما يضمن الدقة والمعلومات المحدثة."
          },
          {
            type: "faq",
            question: "هل يمكنني توليد بوكيمون من جيل معين؟",
            answer: "نعم، يمكنك التصفية حسب الجيل من الأول إلى الثامن، أو اختيار \"الكل\" لتضمين جميع الأجيال."
          },
          {
            type: "faq",
            question: "كيف يعمل فلتر الندرة؟",
            answer: "تخصص خوارزميتنا قيم ندرة بناءً على عوامل مثل الحالة الأسطورية/الأسطورية، والخبرة الأساسية، وسمات أخرى لإنشاء مقياس ندرة من 1 إلى 10."
          },
          {
            type: "faq",
            question: "هل يمكنني حفظ أو تصدير البوكيمون المولدة؟",
            answer: "حالياً، يمكنك التقاط لقطات شاشة لنتائجك. نحن نفكر في إضافة وظائف الحفظ/التصدير في التحديثات المستقبلية."
          },
          {
            type: "faq",
            question: "هل مولّد البوكيمون العشوائي متوافق مع الأجهزة المحمولة؟",
            answer: "نعم، مولّدنا متجاوب بالكامل ويعمل على الهواتف الذكية والأجهزة اللوحية وأجهزة الكمبيوتر المكتبية."
          }
        ]
      }
    ]
  },
  conclusion: {
    content: [
      "يقدم مولّد البوكيمون العشوائي الخاص بنا إمكانيات لا نهائية لكل من المعجبين العاديين والمدربين المتفانين. سواء كنت تبحث عن اكتشاف مفضلات جديدة، أو إنشاء فرق موضوعية، أو تحدي نفسك بمجموعات غير متوقعة، توفر أداتنا طريقة ممتعة وتعليمية لاستكشاف عالم البوكيمون الواسع.",
      "نحن نعمل باستمرار على تحسين المولّد بميزات وخيارات جديدة. جربه اليوم من خلال تحديد تفضيلاتك والنقر على \"توليد\" لمعرفة أي بوكيمون تنتظرك!",
      "شارك نتائجك مع الأصدقاء والمدربين الآخرين، وأخبرنا كيف تستخدم مولّد البوكيمون العشوائي في رحلتك مع البوكيمون. رحلة صيد سعيدة!"
    ]
  }
}; 